import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/index.vue'
import NoResult from './components/404.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/index.html',
    //   name: 'index-html',
    //   component: Index,
    //   redirect: { name: 'home' }
    // },
    // {
    //   path: '/',
    //   name: 'index',
    //   redirect: { name: 'home' }
    // },
    {
      path: '/termsOfService',
      name: 'terms-of-service',
      component: () => import('./components/TermsOfService.vue')
    },
    {
      path: '/PrivacyPolicy',
      name: 'privacy-policy',
      component: () => import('./components/PrivacyPolicy.vue')
    },
    {
      path: '/Agreement',
      name: 'agreement',
      component: () => import('./components/Agreement.vue')
    },
    {
      path: '/',
      name: 'pc',
      component: Index,
      redirect: { name: 'home' },
      children: [
        { path: 'home', name: 'home', component: () => import('./views/home.vue') },
        { path: 'shop', name: 'shop', component: () => import('./views/shop.vue') },
        {
          path: 'shop/pay',
          name: 'shop-pay',
          component: () => import('./views/shop/payment.vue'),
          props: (route) => ({ query: route.query })
        },
        { path: 'shop/result', name: 'shop-success', component: () => import('./views/shop/result.vue') },
        // { path: 'shop/failed', name: 'shop-failed', component: () => import('./views/shop/failed.vue') }
      ]
    },
    // 运营活动
    {
      path: '/poker/home',
      name: 'pc-poker-home',
      meta: {
        favi: '/pc/favi.ico'
      },
      redirect: { name: 'poker-home-contact' },
      component: () => import('./views/poker/home.vue'),
      children: [
        {
          path: '',
          name: 'poker-home-contact',
          component: () => import('./views/poker/contact.vue')
        },
        {
          path: 'contact/complete',
          name: 'poker-home-complete',
          component: () => import('./views/poker/complete.vue')
        }
      ]
    },
    {
      path: '*',
      name: 'NoResult',
      component: NoResult
    }
  ]
})

router.beforeEach((to, from, next) => {
  // if(to.meta.favi) {
  //   alert('fdf')
  //   document.querySelector('.favi').setAttribute('href', '/pc/favi.ico');
  // }
  if (document.body.clientWidth < 1050) {
    if (window.location.href.indexOf('/pc/') !== -1) {
      window.location.href = window.location.href.replace('/pc/', '/mobile/')
    } else {
      window.location.href = '/mobile/home'
    }
  } else {
    next()
  }
})

export default router
